module.exports = __webpack_public_path__ + "img/wxcs.738b8283.png";